export default {"src":"/_next/static/media/0xaf319e5789945197e365e7f7fbfc56b130523b33.668df216.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};